import { jsx as g } from "react/jsx-runtime";
import { useController as F } from "react-hook-form";
import { isDefined as n, isTruthy as T } from "./types3.mjs";
import { CurrencySelect as b } from "./index100.mjs";
import { useCallback as u } from "react";
const q = ({
  control: f,
  name: l,
  defaultValue: m,
  rules: s,
  shouldUnregister: a,
  fullWidth: j = !0,
  size: c,
  label: p,
  color: k,
  variant: w,
  onChange: o,
  onBlur: t,
  currencies: d,
  helperText: h,
  ...C
}) => {
  const {
    field: r,
    fieldState: { error: i }
  } = F({
    name: l,
    control: f,
    rules: s,
    defaultValue: m,
    shouldUnregister: a
  }), v = u(
    (e, y, S) => {
      r.onChange(e), n(o) && o(e, y, S);
    },
    [r, o]
  ), x = u(
    (e) => {
      r.onBlur(), n(t) && t(e);
    },
    [r, t]
  );
  return /* @__PURE__ */ g(
    b,
    {
      label: p,
      name: l,
      onChange: v,
      onBlur: x,
      currencies: d,
      inputRef: r.ref,
      value: r.value ?? "",
      error: T(i),
      helperText: i?.message || h,
      size: c,
      ...C
    }
  );
};
export {
  q as FormCurrencySelectFieldNew
};
//# sourceMappingURL=index101.mjs.map
